var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container help-center"},[_c('leftAbout'),_vm._v(" "),_c('div',{staticClass:"help-main"},[_c('h2',[_vm._v("隐私保护政策")]),_vm._v(" "),_c('iframe',{staticStyle:{"border":"none","width":"100%","height":"100%","display":"block","min-height":"600px"},attrs:{"src":_vm.content}})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3888204e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/user.vue
// module id = null
// module chunks = 